module.exports = __webpack_public_path__ + "assets/img/btn-back-b8ff2132.png";